import { render, staticRenderFns } from "./LivePopularityData.vue?vue&type=template&id=75ea49a6&scoped=true"
import script from "./LivePopularityData.vue?vue&type=script&lang=js"
export * from "./LivePopularityData.vue?vue&type=script&lang=js"
import style0 from "./LivePopularityData.vue?vue&type=style&index=0&id=75ea49a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ea49a6",
  null
  
)

export default component.exports